export const EXTERNAL_FAVORITE_LIST_CARD_CONTENT = {
    ADDRESS_PLACEHOLDER: "Nie znaleźliśmy informacji o lokalizacji",
    MISSING_SPEC: "brak",
    NO_PRICE: "BRAK CENY",
    NO_PRICE_M2: "BRAK CENY ZA METR",
    SUBTITLE_PLACEHOLDER: "Nie znaleźliśmy informacji o nazwie oferty",
    VIEW_SOURCE_OFFER_BUTTON: "Zobacz szczegóły",
    VIEW_SOURCE_OFFER_BUTTON_MOBILE: "Szczegóły",
    VIEW_SOURCE_OFFER_HINT: "Klikając w „zobacz szczegóły” zostaniesz przeniesiony do zewnętrznego portalu w nowym oknie.",
    getPictureAlt: (offerName: string | null) => offerName || "Zdjęcie oferty zewnętrznej"
} as const;
export const EXTERNAL_FAVORITE_LIST_CARD_CONTENT = {
    ADDRESS_PLACEHOLDER: "Nie znaleźliśmy informacji o lokalizacji",
    MISSING_SPEC: "brak",
    NO_PRICE: "BRAK CENY",
    NO_PRICE_M2: "BRAK CENY ZA METR",
    SUBTITLE_PLACEHOLDER: "Nie znaleźliśmy informacji o nazwie oferty",
    VIEW_SOURCE_OFFER_BUTTON: "Zobacz szczegóły",
    VIEW_SOURCE_OFFER_BUTTON_MOBILE: "Szczegóły",
    VIEW_SOURCE_OFFER_HINT: "Klikając w „zobacz szczegóły” zostaniesz przeniesiony do zewnętrznego portalu w nowym oknie.",
    getPictureAlt: (offerName: string | null) => offerName || "Zdjęcie oferty zewnętrznej"
} as const;
